import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
        >
          <path d="M7.778 16.667h4.444v-2.222H7.778v2.222zM0 3.333v2.223h20V3.333H0zm3.333 7.778h13.334V8.89H3.333v2.222z"></path>
        </svg>
    );
}